/**
 * ORBIT 2.0 — Indian Currency Formatting
 * All monetary display must use these helpers.
 * Never use raw .toFixed(2) or plain number formatting for money.
 */

export const formatINR = (amount, options = {}) => {
  const { showSymbol = true, decimals = 2 } = options;
  if (amount === null || amount === undefined || isNaN(amount)) return showSymbol ? '₹0.00' : '0.00';
  const formatted = Number(amount).toLocaleString('en-IN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return showSymbol ? `₹${formatted}` : formatted;
};

export const formatINRCompact = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return '₹0';
  const n = Math.abs(Number(amount));
  if (n >= 10000000) return `₹${(amount / 10000000).toFixed(2)}Cr`;
  if (n >= 100000) return `₹${(amount / 100000).toFixed(2)}L`;
  if (n >= 1000) return `₹${(amount / 1000).toFixed(1)}K`;
  return `₹${Number(amount).toFixed(0)}`;
};

/**
 * FX3 C10 — snake_case keys must never reach the user.
 * "kyc_submitted" → "KYC Submitted", "wrong_bank_details" → "Wrong bank details".
 */
const ACRONYMS = {
  kyc: "KYC", gst: "GST", pan: "PAN", dp: "DP", rto: "RTO", pi: "PI", cn: "CN",
  sku: "SKU", ifsc: "IFSC", oms: "OMS", crm: "CRM", po: "PO", foc: "FOC",
  hsn: "HSN", awb: "AWB", utr: "UTR", id: "ID", url: "URL", cogs: "COGS",
  bom: "BOM", fg: "FG", pm: "PM", rm: "RM", mrp: "MRP", upi: "UPI",
};

export const labelFor = (key, options = {}) => {
  const { sentenceCase = false } = options;
  if (key === null || key === undefined || key === "") return "";
  const words = String(key).replace(/[_-]+/g, " ").trim().split(/\s+/);
  const out = words.map((w, i) => {
    const lower = w.toLowerCase();
    if (ACRONYMS[lower]) return ACRONYMS[lower];
    if (sentenceCase && i > 0) return lower;
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  });
  return out.join(" ");
};

/** Sentence style: only the first word capitalised, acronyms preserved. */
export const sentenceLabel = (key) => labelFor(key, { sentenceCase: true });
